const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

const EXTERNAL_API_BASE_URL = "https://wac-prod.vercel.app/api";

const CUSTOM_EVENTS = {
  affiliateLoaded: 'affiliate-loaded',
};

const REFERSION_CONVERSION_TRIGGER_TYPES = {
  COUPON: 'COUPON',
  SKU: 'SKU',
  EMAIL: 'EMAIL',
};

const QUERY_KEYS = {
  SIGNUP: 'signup',
};